/**
 * @generated SignedSource<<7c28bccc9cc565c2e9ea8d49a1303717>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountMemberKind = "Invitation" | "UserInAccount";
export type groupDetailsAccountMembersRefetchQuery$variables = {
  after?: string | null;
  filterByAccountMemberKind?: AccountMemberKind | null;
  filterByNameOrEmail?: string | null;
  first?: number | null;
  groupId: string;
};
export type groupDetailsAccountMembersRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"groupDetails_QueryFragment">;
};
export type groupDetailsAccountMembersRefetchQuery = {
  response: groupDetailsAccountMembersRefetchQuery$data;
  variables: groupDetailsAccountMembersRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByAccountMemberKind"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByNameOrEmail"
  },
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "filterByAccountMemberKind",
  "variableName": "filterByAccountMemberKind"
},
v3 = {
  "kind": "Variable",
  "name": "filterByNameOrEmail",
  "variableName": "filterByNameOrEmail"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInAccountGroup",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "groupDetailsAccountMembersRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "groupId",
            "variableName": "groupId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "groupDetails_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "groupDetailsAccountMembersRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementQueries",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v2/*: any*/),
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "filterByGroupIds.0",
                    "variableName": "groupId"
                  }
                ],
                "kind": "ListValue",
                "name": "filterByGroupIds"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AccountMembersResult",
            "kind": "LinkedField",
            "name": "AccountMembers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invitationCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "AccountMemberConnection",
                "kind": "LinkedField",
                "name": "accountMembers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountMemberEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isAccountMember"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserInAccount",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "userExtensionKind",
                                            "value": "Academies"
                                          }
                                        ],
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "extension",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "firstName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lastName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "File",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "thumbnail",
                                                    "storageKey": null
                                                  },
                                                  (v7/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "sumGamificationPoints",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "AcademiesUserExtension",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": "extension(userExtensionKind:\"Academies\")"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isManager",
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "UserInAccountWrapper",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Invitation",
                                "kind": "LinkedField",
                                "name": "invitation",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              (v10/*: any*/)
                            ],
                            "type": "InvitationWrapper",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "groupDetails_accountMembers",
                "kind": "LinkedHandle",
                "name": "accountMembers"
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e5d01695590dec6c8bcab68c4c4dd05",
    "id": null,
    "metadata": {},
    "name": "groupDetailsAccountMembersRefetchQuery",
    "operationKind": "query",
    "text": "query groupDetailsAccountMembersRefetchQuery(\n  $after: String = null\n  $filterByAccountMemberKind: AccountMemberKind\n  $filterByNameOrEmail: String = null\n  $first: Int = 100\n  $groupId: ID!\n) {\n  ...groupDetails_QueryFragment_3XX6Ix\n}\n\nfragment groupDetails_QueryFragment_3XX6Ix on Query {\n  AccountMemberManagement {\n    AccountMembers(filterByGroupIds: [$groupId], filterByNameOrEmail: $filterByNameOrEmail, filterByAccountMemberKind: $filterByAccountMemberKind) {\n      userCount\n      invitationCount\n      accountMembers(first: $first, after: $after) {\n        edges {\n          node {\n            __typename\n            id\n            kind\n            ... on UserInAccountWrapper {\n              user {\n                user {\n                  id\n                  ...userInGroupContextMenu_UserFragment\n                }\n                id\n              }\n            }\n            ... on InvitationWrapper {\n              invitation {\n                id\n                email\n              }\n            }\n            ...userCard_UserInAccountWrapperFragment\n            ...invitationCard_InvitationFragment\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n}\n\nfragment invitationCard_InvitationFragment on AccountMember {\n  __isAccountMember: __typename\n  ... on InvitationWrapper {\n    invitation {\n      id\n      email\n    }\n    groups {\n      id\n      name\n    }\n  }\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n\nfragment userCard_UserInAccountWrapperFragment on UserInAccountWrapper {\n  id\n  name\n  isManager\n  groups {\n    id\n    name\n  }\n  user {\n    user {\n      id\n      name\n      email\n      ...userAvatar_UserFragment\n    }\n    id\n  }\n}\n\nfragment userInGroupContextMenu_UserFragment on User {\n  id\n  name\n  email\n}\n"
  }
};
})();

(node as any).hash = "0e807ce6cbde2c98dbedc6f3c7ad2069";

export default node;
